import { render } from "./ReportChart.vue?vue&type=template&id=745d7890&scoped=true"
import script from "./ReportChart.vue?vue&type=script&lang=js"
export * from "./ReportChart.vue?vue&type=script&lang=js"

import "./ReportChart.vue?vue&type=style&index=0&id=745d7890&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-745d7890"]])

export default __exports__